import React, {useContext} from "react";
import './Biographie.scss';
import { SettingsContext } from 'Providers/SettingsProvider';
import Utils from 'utils/Utils';


function Biographie({artiste}) {
  const { t, translate } = useContext(SettingsContext);
  return <div className="biographie">
  <div className="biographie-titre">{t('biographie')}</div>
  <div className="biographie-nom">{artiste.name}</div>
  <div className="biographie-text select">
    {Utils.parseWithLinks(translate(artiste,'bio'))}
  </div>
  </div>
}

export default Biographie;
